<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Terminal Audit</li>
            </ol>
          </div>
          <h4 class="page-title">Terminal Management</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Terminals</h4>
          <p class="sub-header">
            Create and edit terminals for your current terminal
          </p>

          <div class="row">

            <div class="col-12">
              <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table table-striped mb-0" style="width: 100%">
                <thead>
                  <tr>
                    <th>Terminal Id</th>
                    <th>Name</th>
                    <th>Merchant number</th>
                    <th>Active</th>
                    <th class="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let terminal of terminals">
                    <td>{{ terminal.id}}</td>
                    <td>{{ terminal.shortName}}</td>
                    <td>{{ terminal.cardAcceptor}}</td>
                    <td>
                      <i class="mdi mdi-check table-icon" *ngIf="!!terminal.termActive"></i>
                      <i class="mdi mdi-close table-icon" *ngIf="!terminal.termActive"></i>
                    </td>
                    <td>
                      <button type="button" [style]="ViewButtonStyle" class="btn btn-icon waves-effect waves-light btn-outline-primary fa-pull-right" (click)="viewTerminal(terminal)">
                        <i class="mdi mdi-pencil-box-outline"></i>View
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>

      </div>

    </div>

  </div> <!-- end container -->
</div>
